import { CalculatorInterface } from "./calc_interface.js"


export class CalculatorComplex extends CalculatorInterface {
    /**
     * Scans document or node (if htmlNode is set)
     * @param {any} htmlNode - set if you need to scan fields inside specific node (useful for dynamic content)
     * @returns {Object} {inputs, outputs}
     */
    fetchFields(htmlNode) {
        const calc_ = this;
        if (htmlNode == undefined)
            htmlNode = document;
        const $node = $(htmlNode);

        function scopeEvalFunc(underscore, script) {
            return new Function(`"use strict"; const cc = this; const _ = cc["${underscore}"]; return ${script};`).bind(calc_);
        }

        function parseNameType(text) {
            const parts = /^(\[(.*?)\])?([^\[\]\:]+)(\:(.+))?$/g.exec(text);
            if (parts === null) {
                throw new Error(`Incorrect format for cc:input value ("${attr}"). Must be "name" or "[type]name"`);
            }
            const paramString = parts[5];
            const options = (parts[2] !== undefined ? { type: parts[2] } : {});

            if (paramString !== undefined) {
                paramString.match(/(?:[^,\s\[]+(?:\[.*?\])?)(?=\s*,|\s*$)/g).forEach(item => {
                    const splitPos = item.indexOf('=');
                    if (splitPos < 0) {
                        console.warn(`Incorrect option value '${item}'. Must be something like 'option=value'. Ignoring...`);
                        return false;
                    }
                    const varName = item.substr(0, splitPos);
                    let value = item.substr(splitPos + 1);

                    if (/^\d+$/.test(value)) {
                        value = parseInt(value);
                    }
                    else if (/^\d+(\.\d+)?$/.test(value)) {
                        value = parseFloat(value);
                    }
                    else if (/^false|true$/i.test(value)) {
                        value = (value.toLowerCase() === 'true');
                    }
                    else if (/^\[.*\]$/.test(value)) {
                        value = value.slice(1, -1).split(',').map(e => e.trim());
                    }
                    else {
                        try {
                            value = JSON.parse(value);
                        } catch (e) {}
                    }

                    options[varName] = value;
                });
            }
            return { name: parts[3], options };
        }

        function checkClass(el) {
            const class_ = $(el).closest('[cc\\:class]');
            if (class_.length > 0 && class_[0].getAttribute('cc:class') !== calc_.autoKey()) {
                return false;
            }
            const inTemplate = $(el).closest('.template-list-row').length > 0;
            return !inTemplate;
        }

        $node.find('[cc\\:click]').map((index, el) => {
            if(checkClass(el)){
                const self = this;
                const clickOptions = parseNameType(el.getAttribute('cc:click'));
                $(el).on('click', function () {
                    const result = scopeEvalFunc('_', clickOptions.name)();
                    if (clickOptions?.options?.submit !== false){
                        self.autoSubmit(null, true);  
                    }
                    return result;
                });
            }
        });

        this.toggleClasses = $node.find('[cc\\:classname]').toArray().map(el => {
            const attr = el.getAttribute("cc:classname");
            const classesObj = JSON.parse(attr);
            
            return {
                toggle: () => {
                    for(let className in classesObj) {
                        const condition = classesObj[className];
                        if (scopeEvalFunc('_', condition)()) {
                            el.classList.add(className);
                        } else {
                            el.classList.remove(className);
                        }
                    }
                }
            }
        });

        return {
            inputs: $node.find('[cc\\:input]').toArray().map(el => {
                if (checkClass(el)) {
                    const attr = el.getAttribute('cc:input');
                    const { name, options } = parseNameType(attr);
                    return [el, name, options];
                } else {
                    return null;
                }
            }),
            outputs: $node.find('[cc\\:output]').toArray().map(el => {
                if (checkClass(el)) {
                    const attr = el.getAttribute('cc:output');
                    let { name, options } = parseNameType(attr);
                    const renderCode = el.getAttribute('cc:render');

                    if (renderCode !== null) {
                        options.render = function (x) { return scopeEvalFunc(name, renderCode)(); }
                    }

                    if (Object.keys(options).length === 0)
                        options = undefined;

                    return [el, name, options];
                } else {
                    return null;
                }
            }).concat($node.find('[cc\\:if]').toArray().map(el => {
                if (checkClass(el)) {
                   
                    let attr = el.getAttribute('cc:if');
                    if (attr[0] == '@') {
                        attr = $(attr.substr(1))[0].getAttribute('cc:if');
                    }
                    return [el, "", { type: "toggle", render: function () { return scopeEvalFunc('_', attr)(); } }];
                } else {
                    return null;
                }
            })).concat($node.find('[cc\\:ifhash]').toArray().map(el => {
                if(checkClass(el)){
                    let attr = el.getAttribute('cc:ifHash');
                    let self = this;

                    return [el, "", { type: "toggle", render: function () { 
                        return self.checkHash(attr);
                    } }];
                }
                return null;
            })).concat($node.find('[cc\\:forceif]').toArray().map(el => {
                if (checkClass(el)) {
                    let attr = el.getAttribute('cc:forceIf');
                    if (attr[0] == '@') {
                        attr = $(attr.substr(1))[0].getAttribute('cc:forceif');
                    }
                    return [el, "", {type: "toggle", render: function () {return scopeEvalFunc('_', attr)();}}, true];
                } else {
                    return null;
                }
            })),
        }
    }
    

    writePath(obj, path, value, gentle=false) {
        if (Array.isArray(obj)) {
            obj.forEach(o => this.writePath(o, path, value, gentle));
            return;
        }

        let parts = path.split('.');
        let target = obj;
        parts.forEach(function (part, index) {
            if (target !== null) {
                if (part.indexOf('[]') >= 0) {
                    let id_ = /[:]\d+/.exec(part);
                    id_ = (id_ == null ? -1 : id_[0]);
                    let clearPart = part.replace(/([:]\d+)\[\]/g, '');
                    if (target[clearPart] === undefined)
                        target[clearPart] = [];
                    if (!target[clearPart].some(o => {
                        if (o.__id == id_) {
                            target = o;
                            return true;
                        }
                    })) {
                        if (gentle) { target = null; return true; }
                        target[clearPart].push((id_ < 0 ? {} : { __id: id_ }));
                        target = target[clearPart][target[clearPart].length - 1];
                    }
                } else {
                    if (index == parts.length - 1) {
                        target[part] = value;
                    } else {
                        if (target[part] === undefined) {
                            if (gentle) { target = null; return true; }
                            target[part] = {};
                        }
                        target = target[part];
                    }
                }
            }
        });
    }


    /**
     * 
     * @param {string} name (where value saves: this.<name>[].key
     * @param {*} params next keys:
     *      required:
     *          table - where to place our elements
     *          appendButtonSelector - selector for button which will add new item of this dynamic field
     *          removeSelector - selector (inside template) which deletes particular item
     *          fields - object {<name>: {selector, options($clone)}}
     *          
     *      optional: 
     *          removeFirstEvent() - make some additional acts during removing
     *          keepOne - true when one element cannot be deleted(false by default)
     *          keepTable - true when table should be shown, even when keepOne=false (false by default)
     *          ignoreForEmpty - if true, block wil be ignored if all fields are empty
     *          prepareTemplate($clone, blockPiece) should return {block: $clone, artifacts: obj(optional)
     *              (this method can help you to prepare item before placing)
     *          beforeRemoval($clone) - make some additional acts before removal
     *          afterRemoval() - make some additional acts after removal
     *          dontSubmitOnRemove - turning off submitForm in remove()
     */
    addDynamicField(name, params){
        let self = this;
        let parent = params.parent || $(document.body);
        let fetchRootElem = (selector) => typeof (selector) == "string" ? tools.findExternalOnly(parent, selector) : $(selector);
        let $table = fetchRootElem(params.table);
        let $dataExpandableDiv = $(`.expandablerow[data-expandablediv = '${$table.parent().attr("id")}']`);
        let elements = [];

        
        function createClone(silent) {
            let $template = tools.findExternalOnly($table, ".template-list-row");
            let $lastRow = tools.findExternalOnly($table, '.dynamic-list-row').last();
            let $clone = $($table[0].querySelector(".template-list-row").cloneNode(true));
            let _id = self.genUniqueId();

            let blockPiece = {
                index: (() => {
                    const valid = elements.filter(e => !e.removed);
                    return valid.length > 0 ? valid[valid.length - 1].index + 1 : 0;
                })(),
                fields: [],
                reset: function() {
                    if (tools.findExternalOnly($table, '.dynamic-list-row').length > 1 || !params.keepOne) {
                        if (params.beforeRemoval !== undefined) {
                            params.beforeRemoval($clone);
                        }
                        $clone.remove();
                        this.fields.map(field => field.delete());
                        this.removed = true;
                        if (params.afterRemoval !== undefined) {
                            params.afterRemoval();
                        }
                    } else {
                        this.index = 0;
                    }
                },
                isFilled: function () {
                    return this.fields.some(f => f.isFilled());
                },
                artifacts: [],
                getFieldsFlat: function () {
                    let result = [];
                    this.fields.forEach(f => {
                        if (f.isDynamic) {
                            f.getElements().forEach(e => {
                                result = result.concat(e.getFieldsFlat());
                            });
                        } else {
                            result.push(f);
                        }
                    });
                    return result;
                },
                tree: {},
                removed: false,
                remove: function () {
                    this.removed = true;
                    let elementsCount = elements.filter(x => !x.removed).length
                    if (elementsCount === 0) {
                        if (!params.keepOne) {
                            $clone.closest('div').hide();
                            $clone.closest('.expandable-div').find('.expandablerow').addClass('expandablerow-collapsed');
                            $clone.closest('.expandable-div').find(".tab-expandablerow-add").attr("tabindex", "0");
                        }else{
                            this.removed = false;
                        }
                        if (params.removeFirstEvent !== undefined)
                            params.removeFirstEvent();
                    }
                    this.reset();
                    if (!params.dontSubmitOnRemove)
                        self.submitForm(null, !self._submitOnChange);
                }
            }

            $clone.removeClass('template-list-row').addClass('dynamic-list-row');

            // auto fields
            self.fetchFields($clone).inputs.forEach(([el, item, options]) => {
                const fieldParams = { disabledSubmitting: true, parent: $clone, ...options };
                const field = self.addInputField(el, `${name}:${_id}[].${item}`, fieldParams);
                blockPiece.tree[item] = field;
                blockPiece.fields.push(field);
            });

            if (params.fields !== undefined) {
                for (let item in params.fields) {
                    let value = params.fields[item];
                    let fieldParams = {};
                    if (typeof (value) === "string") {
                        value = { selector: value };
                    } else if (value.options !== undefined) {
                        fieldParams = typeof (value.options) === "function" ? value.options($clone) : value.options;
                    }
                    fieldParams.disabledSubmitting = true;
                    fieldParams.parent = $clone;

                    const field = self.addInputField($clone.find(value.selector), `${name}:${_id}[].${item}`, fieldParams);
                    blockPiece.tree[item] = field;
                    blockPiece.fields.push(field);
                }
            }

            $clone.find(params.removeSelector).first().click((e) => {
                e.preventDefault();
                blockPiece.remove();
                $(e.target).blur();
            });

            let anchor = $lastRow.length === 1 ? $lastRow : $template;
            params.prepareTemplate = params.prepareTemplate || (c => { return { block: c }; });
            const { block, artifacts } = params.prepareTemplate($clone, blockPiece);
            anchor[0].insertAdjacentElement('afterEnd', block[0]);

            if (artifacts !== undefined) {
                for (let key in artifacts) {
                    blockPiece.artifacts.push({
                        path: `${name}:${_id}[].${key}`,
                        value: artifacts[key],
                        name: self.removePathId(`${name}:${_id}[].${key}`),
                    });
                    blockPiece.tree[key] = artifacts[key];
                }
            }

            elements.push(blockPiece);

            if (!silent) {
                self.submitForm(null, !self._submitOnChange);
            }

            blockPiece.fields.forEach(f => { f.params_.disabledSubmitting = false; });
        }

        if(params.keepOne)
            createClone(true);

        fetchRootElem(params.appendButtonSelector).click(() => createClone());

        // AG TODO: WILL NOT WORK WITH DYNAMIC-IN-DYNAMIC. NEED TO BE REFACTORED!
        $dataExpandableDiv.click(function () {
            var $this = $(this);
            if ($this.hasClass('expandablerow-collapsed')) {
                $this.removeClass('expandablerow-collapsed');

                var $expandableDiv = $('#' + $this.data('expandablediv'));
                $expandableDiv.show();

                $this.find(".tab-expandablerow-add").attr("tabindex", "-1");

                if (tools.findExternalOnly($expandableDiv, '.dynamic-list-row').length === 0) {
                    createClone();
                }
            }
        });

        let result = {
            isDynamic: true,
            reset: function () {
                elements.forEach((item) => item.reset());
                if (!params.keepOne) {
                    if (!params.keepTable)
                        $table.parent().hide();
                    $dataExpandableDiv.addClass('expandablerow-collapsed');
                }
                if (params.removeFirstEvent !== undefined)
                    params.removeFirstEvent();
            },
            params_: params,
            getElements: function () {
                return elements.filter(bp => !bp.removed);
            },
            delete: function () {
                elements.forEach((item) => item.fields.forEach(f => f.delete()));
            },
            isFilled: function () { return elements.some(e => e.isFilled()); },
            ignoredEmptyFields: function () {
                let result = [];
                if (params.ignoreForEmpty) {
                    elements.forEach((e) => {
                        if (!e.isFilled()) {
                            result = result.concat(e.getFieldsFlat().map(f => f.varName));
                        }
                    });
                }
                return result;
            },
            setCount: function ({count, removeStrategy = "simple" }) {
                let currentCount = this.getElements().length;
                if (count !== currentCount) {
                    if (count > currentCount) {
                        while (this.getElements().length < count)
                            createClone();
                    } else {
                        if (removeStrategy === "simple") {
                            this.getElements().forEach((bp, i) => { if (i >= count) bp.remove(); });
                        }
                    }
                }
            }
        };

        this._dynamicFields.push(result);

        if (params.keepOne && !params.disabledSubmitting)
            self.submitForm(null, !self._submitOnChange);

        return result;
    }


    /**
     * Adds group of fields to calculator.
     * @param {any} nameOrNames to fetch all fields you need
     * @param {any} checker function f(fields, options) which returns object {valid: bool, artifacts: obj}
     * @param {any} options is additional parameters for group
     */
    addGroup(nameOrNames, checker, options) {
        let self = this;

        this.fieldGroups.push({
            getFields: function () {
                let resList = [];
                function checkField(f, name) {
                    return !f.ignore && !f.__tmpIgnore && self.isPathInside(f.name, name);
                }
                if (typeof (nameOrNames) === 'string') {
                    nameOrNames = [nameOrNames];
                }

                nameOrNames.forEach(function (name) {
                    resList = resList.concat(self.inputFields.filter(f => checkField(f, name)));
                });

                resList.tree = {};
                resList.forEach((f) => { self.writePath(resList.tree, f.varName, f); });

                self._dynamicFields.forEach(df => {
                    df.getElements().forEach(e => {
                        e.artifacts.filter(a => nameOrNames.some(name => self.isPathInside(a.name, name))).forEach(a => {
                            self.writePath(resList.tree, a.path, a.value);
                        });
                    });
                });

                return resList;
            },
            check: function (sender, autoValidation) {
                let fields = this.getFields();
                let newOptions = { sender: sender, autoValidation: autoValidation };
                for (let key in options) {
                    newOptions[key] = options[key];
                }
                return checker(fields, newOptions);
            }
        });
    }


    /**
     * Parses all input fields and initialises connected variables
     * */
    parse(sender, autoValidation) {
        var self = this;
        const newValues = this.irregularValueNames.reduce((acc, v) => { acc[v] = self[v]; return acc; }, {});
        this.log("Irregular value obj:", newValues);
        this.inputFields.forEach(function (field) {
            field.__tmpIgnore = false;
            self.clearPath(self, field.name);
            self.clearPath(self._exportObject.parse, field.name);
        });

        let ignoreList = this._dynamicFields.reduce((accum, v) => accum.concat(v.ignoredEmptyFields()), []);
        this.inputFields = this.inputFields.filter(function (f) { return !f.deleted; });

        var result = {
            valid: true,
            filled: this.defaultFilled,
            enableResetButton: false,
            hasValueChanges: false
        };

        let fieldsToParse = this.inputFields.filter(function (f) {
            let ignoreCouseEmpty = ignoreList.indexOf(f.varName) >= 0;
            if (f.showReset()) {
                result.enableResetButton = true;
            }
            if (f.ignore)
                f.reset({ keepValue: !self.resetValuesOnIgnore });
            else if (ignoreCouseEmpty) {
                f.__tmpIgnore = true;
                f.reset({ keepValue: true });
            }
            return !f.ignore && !ignoreCouseEmpty;
        });

        const unsilence = [];
        if (sender) {
            const senderField = fieldsToParse.find(f => sender == f.elem[0]);
            if (senderField && senderField.params_.unsilence)
                unsilence.push(...senderField.params_.unsilence);
        }
        
        // first phase
        fieldsToParse.forEach(function (field) {
            var res = field.check(autoValidation, sender, 1, unsilence.indexOf(field.name) >= 0);
            field.valid = res;

            if (field.isFilled()) {
                result.filled = true;
            }
            if (field.errorIsVisible()) {
                result.enableResetButton = true;
            }

            if (!res)
                result.valid = false;
            else if (field.name !== undefined) {
                self.writePath([self, newValues], field.varName, field.getValue());
                self.writePath(self._exportObject.parse, field.varName, field.getExportValue());
            }
        });

        // dynamicField artifacts
        this._dynamicFields.forEach(df => {
            df.getElements().forEach(e => {
                e.artifacts.forEach(a => {self.writePath([self, newValues], a.path, a.value, true);});
            });
        });

        this.afterFirstPhaseCheck();

        // second phase
        fieldsToParse.forEach(function (field) {
            var res = field.check(autoValidation, sender, 2);
            if (!res)
                result.valid = field.valid = false;
        });
        if (!autoValidation) {
            const newValuesString = JSON.stringify(newValues);
            result.hasValueChanges = this.lastValuesString !== newValuesString;
            this.lastValuesString = newValuesString;
        }

        this.fieldGroups.forEach(group => {
            let res = this.processGroup(group, sender, autoValidation);
            if (!res)
                result.valid = false;
        });

        this.log("PARSE: ", this);
        result.enableResetButton = result.enableResetButton || result.filled;
        this.afterParse(sender, autoValidation);
        this.forceRender();
        return result;
    }



    submitForm(sender, autoValidation, skipValueChangesCheck = false) {
        if(!this.isActive) return;
        this._exportObject = {
            parse: {},
            render: {notes: []}
        };
        
        if (this.beforeSubmit() === false) {
            return;
        }

        let parsing = this.parse(sender, autoValidation);
        this.resetButtons.forEach(function (elem) {
            (parsing.enableResetButton ? elem.show() : elem.hide());
        });

        if (parsing.filled && !this._statistic.startedSent) {
            this.sendStatisticMessage('Is_Started');
            this._statistic.startedSent = true;
        }

        if (!this.isReady()) {
            return;  // AG TODO: Maybe wait for ready? Design how to do it.
        }

        this.log("BEFORE CALC: valid=", parsing.valid);
       
        if (!this.calculateForValidOnly || parsing.valid) {
            this.toggleCustomClasses();
            let calcValid = this.calculate({ sender: sender, autoValidation: autoValidation });
            this.log('AFTER CALCULATE: ', this);
            if (!autoValidation && (skipValueChangesCheck || parsing.hasValueChanges)) {
                if (parsing.valid && calcValid) {
                    this.beforeRender();
                    this.render();
                    this._exportObjectFinal = tools.deepcopy(this.generateExportObject());
                    this.showResults();
                } else {
                    this.hideResults();
                }
            }
        }

        if (!parsing.valid && !autoValidation) {
            this.renderError();
        }

        this.log("EXPORT OBJECT:", this._exportObject);
        this.afterSubmit();
    }
    
}
